<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>选择表：</label>
                <el-select v-model="search_Obj.table_name" clearable filterable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option label="00" value="00"> </el-option>
                    <el-option label="01" value="01"> </el-option>
                    <el-option label="02" value="02"> </el-option>
                    <el-option label="03" value="03"> </el-option>
                    <el-option label="04" value="04"> </el-option>
                    <el-option label="05" value="05"> </el-option>
                    <el-option label="06" value="06"> </el-option>
                    <el-option label="07" value="07"> </el-option>
                    <el-option label="08" value="08"> </el-option>
                    <el-option label="09" value="09"> </el-option>
                    <el-option label="10" value="10"> </el-option>
                    <el-option label="11" value="11"> </el-option>
                    <el-option label="12" value="12"> </el-option>
                    <el-option label="13" value="13"> </el-option>
                    <el-option label="14" value="14"> </el-option>
                    <el-option label="15" value="15"> </el-option>
                    <el-option label="16" value="16"> </el-option>
                    <el-option label="17" value="17"> </el-option>
                    <el-option label="18" value="18"> </el-option>
                    <el-option label="19" value="19"> </el-option>
                    <el-option label="20" value="20"> </el-option>
                    <el-option label="21" value="21"> </el-option>
                    <el-option label="22" value="22"> </el-option>
                    <el-option label="23" value="23"> </el-option>
                    <el-option label="24" value="24"> </el-option>
                    <el-option label="25" value="25"> </el-option>
                    <el-option label="26" value="26"> </el-option>
                    <el-option label="27" value="27"> </el-option>
                    <el-option label="28" value="28"> </el-option>
                    <el-option label="29" value="29"> </el-option>
                    <el-option label="30" value="30"> </el-option>
                    <el-option label="31" value="31"> </el-option>
                    <el-option label="32" value="32"> </el-option>
                    <el-option label="33" value="33"> </el-option>
                    <el-option label="34" value="34"> </el-option>
                    <el-option label="35" value="35"> </el-option>
                    <el-option label="36" value="36"> </el-option>
                    <el-option label="37" value="37"> </el-option>
                    <el-option label="38" value="38"> </el-option>
                    <el-option label="39" value="39"> </el-option>
                    <el-option label="40" value="40"> </el-option>
                    <el-option label="41" value="41"> </el-option>
                    <el-option label="42" value="42"> </el-option>
                    <el-option label="43" value="43"> </el-option>
                    <el-option label="44" value="44"> </el-option>
                    <el-option label="45" value="45"> </el-option>
                    <el-option label="46" value="46"> </el-option>
                    <el-option label="47" value="47"> </el-option>
                    <el-option label="48" value="48"> </el-option>
                    <el-option label="49" value="49"> </el-option>
                    <el-option label="50" value="50"> </el-option>
                    <el-option label="51" value="51"> </el-option>
                    <el-option label="52" value="52"> </el-option>
                    <el-option label="53" value="53"> </el-option>
                    <el-option label="54" value="54"> </el-option>
                    <el-option label="55" value="55"> </el-option>
                    <el-option label="56" value="56"> </el-option>
                    <el-option label="57" value="57"> </el-option>
                    <el-option label="58" value="58"> </el-option>
                    <el-option label="59" value="59"> </el-option>
                    <el-option label="60" value="60"> </el-option>
                    <el-option label="61" value="61"> </el-option>
                    <el-option label="62" value="62"> </el-option>
                    <el-option label="63" value="63"> </el-option>
                    <el-option label="64" value="64"> </el-option>
                    <el-option label="65" value="65"> </el-option>
                    <el-option label="66" value="66"> </el-option>
                    <el-option label="67" value="67"> </el-option>
                    <el-option label="68" value="68"> </el-option>
                    <el-option label="69" value="69"> </el-option>
                    <el-option label="70" value="70"> </el-option>
                    <el-option label="71" value="71"> </el-option>
                    <el-option label="72" value="72"> </el-option>
                    <el-option label="73" value="73"> </el-option>
                    <el-option label="74" value="74"> </el-option>
                    <el-option label="75" value="75"> </el-option>
                    <el-option label="76" value="76"> </el-option>
                    <el-option label="77" value="77"> </el-option>
                    <el-option label="78" value="78"> </el-option>
                    <el-option label="79" value="79"> </el-option>
                    <el-option label="80" value="80"> </el-option>
                    <el-option label="81" value="81"> </el-option>
                    <el-option label="82" value="82"> </el-option>
                    <el-option label="83" value="83"> </el-option>
                    <el-option label="84" value="84"> </el-option>
                    <el-option label="85" value="85"> </el-option>
                    <el-option label="86" value="86"> </el-option>
                    <el-option label="87" value="87"> </el-option>
                    <el-option label="88" value="88"> </el-option>
                    <el-option label="89" value="89"> </el-option>
                    <el-option label="90" value="90"> </el-option>
                    <el-option label="91" value="91"> </el-option>
                    <el-option label="92" value="92"> </el-option>
                    <el-option label="93" value="93"> </el-option>
                    <el-option label="94" value="94"> </el-option>
                    <el-option label="95" value="95"> </el-option>
                    <el-option label="96" value="96"> </el-option>
                    <el-option label="97" value="97"> </el-option>
                    <el-option label="98" value="98"> </el-option>
                    <el-option label="99" value="99"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>日期：</label>
                <el-input v-model="search_Obj.f_day" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>邮箱：</label>
                <el-input v-model="search_Obj.f_email" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>CarId：</label>
                <el-input v-model="search_Obj.f_car_id" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="day" label="日期" sortable="custom"></el-table-column>
                <el-table-column prop="email" label="邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="car_id" label="CarId" sortable="custom"></el-table-column>
                <el-table-column prop="drive_count" label="行驶次数" sortable="custom"></el-table-column>
                <el-table-column prop="mileage" label="行驶里程" sortable="custom"></el-table-column>
                <el-table-column prop="charge_count" label="充电次数" sortable="custom"></el-table-column>
                <el-table-column prop="add_time" label="记录时间" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看日报告"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'carDailyList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '日报告',
            menu_id: 5100,
            list_url: "/api/admin/cardaily/list",
            search_Obj: {
                table_name: '00',
                f_email: '',
                f_car_id: '',
                f_day: ''
            },
            del_Obj:{
                url:'/api/admin/cardaily/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>